import { __ } from '@wordpress/i18n';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const swiper_oplossingen = new Swiper('.swiper-oplossingen', {
    modules: [Navigation, Pagination],
    navigation: {
        nextEl: '.swiper-oplossingen-button-next',
        prevEl: '.swiper-oplossingen-button-prev',
    },
    slidesPerView: 1.3,
    spaceBetween: 40,
    breakpoints: {
        1200: {
            slidesPerView: 4,
            spaceBetween: 100,
        },
        992: {
            slidesPerView: 3.5,
            spaceBetween: 60,
        },
        768: {
            slidesPerView: 2.5,
            spaceBetween: 60,
        },
        576: {
            slidesPerView: 2,
            spaceBetween: 40,
        }
    }
});